const messages: Record<string, string> = {
	'blockedByDevice.headline': 'Použite smartfón',
	'blockedByDevice.paragraph.first':
		'Tento odkaz je možné použiť iba na smartfóne. Prosím, nasnímajte QR kód pre pokračovanie.',
	'blockedByDevice.paragraph.second':
		'Tip: Pri otvorení odkazu sa nachádzajte v blízkosti vozidla a majte pripravené potrebné doklady.',
	'button.continue': 'Pokračovať',
	'button.hint': 'Kde nájdem VIN číslo?',
	'button.next': 'Pokračovať',
	'button.photo.take': 'Odfotiť',
	'button.start': 'Začať',
	'damagedImages.booleanRadioGroupLabel': 'Je vaše vozidlo poškodené?',
	'damagedImages.booleanRadioGroupLabelLeft': 'Nie',
	'damagedImages.booleanRadioGroupLabelRight': 'Áno',
	'damagedImages.description':
		'Môžete pridať až {imageCount,  plural, one {# fotku} few {# fotky} other {# fotiek}}.',
	'additionalDamagePictures.title': 'Fotky poškodenia zblízka',
	'dashboardMileage.paragraph.first': 'Zadajte aktuálny stav kilometrov vozidla',
	'dashboardMileage.placeholder.updated': 'km',
	'dashboardMileage.title': 'Najazdené kilometre',
	'feedback.button.send': 'Odoslať hodnotenie',
	'feedback.error.maxLength': 'Komentár môže obsahovať najviac 500 znakov.',
	'feedback.helpImprove': 'Komentár',
	'feedback.message': 'Ako ste boli spokojný s digitálnou obhliadkou? (5 hviezdičiek je najviac)',
	'feedback.title': 'Prosím, ohodnoťte nás',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Odfoťte prednú stranu technického preukazu',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Fotka technického preukazu',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Odfoťte zadnú stranu technického preukazu',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title': 'Fotka technického preukazu',
	'vehicleRegistrationDocument.title': 'Údaje o vozidle',
	'hint.vin.description': 'VIN číslo sa zvyčajne nachádza na jednom z týchto 4 miest:',
	'hint.vin.location1': 'Na prístrojovej doske, viditeľné cez čelné sklo na strane vodiča.',
	'hint.vin.location2': 'Na ráme dverí vodiča, v blízkosti zámku.',
	'hint.vin.location3': 'V motorovom priestore, často na kovovom štítku.',
	'hint.vin.location4': 'Na prednej časti rámu vozidla (staršie vozidlá).',
	'hint.vin.title': 'Možné umiestnenie VIN čísla',
	'onboarding.camera': 'Fotky je možné vyhotoviť iba pomocou fotoaparátu vo vašom smartfóne.',
	'onboarding.documents':
		'Pripravte si kľúče a osvedčenie o evidencii vozidla (technický preukaz).',
	'onboarding.headline': 'Ste pripravený začať digitálnu obhliadku?',
	'onboarding.internet':
		'Uistite sa, že sa nachádzate na dobre osvetlenom mieste so stabilným internetovým pripojením.',
	'onboarding.paragraph': 'Pred začatím obhliadky, prosím, dbajte na nasledujúce:',
	'onboarding.terms.before': 'Pred začatím, prosím, potvrďte nasledujúce:',
	'onboarding.terms.url': 'Súhlasím s <tclink>podmienkami používania</tclink>.',
	'onboarding.vehicle':
		'Uistite sa, že je vozidlo čisté, prístupné zo všetkých strán a všetky okná sú zatvorené.',
	'onboardingStart.headline': 'Dobrý deň, skontrolujte údaje a kliknite na tlačidlo nižšie.',
	'onboardingStart.plateNumber': 'Evidenčné číslo vozidla:',
	'onboardingStart.timeout': 'Obhliadku vozidla vykonajte najneskôr do ',
	'overallDashboardImage.description':
		'Odfoťte celú palubnú dosku tak, aby boli všetky ovládacie prvky dobre viditeľné.',
	'overallDashboardImage.title': 'Celkový pohľad na palubnú dosku',
	poweredBy: 'Technológiu poskytuje <ce>ControlExpert</ce>, člen skupiny <solvd>Solvd</solvd>',
	'review.paragraph.first': 'Po kliknutí na Ďalej skontrolujeme vaše fotky a údaje.',
	'review.stepDescription.damageImages': 'Fotky poškodenia',
	'review.stepDescription.group.perspectiveImages': 'Celkové fotky vozidla',
	'review.stepDescription.group.additionalImages': 'Doplňujúce fotky',
	'review.stepDescription.fourAdditionalDocuments': 'Údaje o vozidle',
	'review.stepDescription.questions': 'Údaje o vozidle',
	'review.title': 'Súhrn digitálnej obhliadky',
	'review.stepDescription.vehicleRearLeftPerspective': 'Diagonálny pohľad na vozidlo zozadu zľava',
	'review.stepDescription.vehicleFrontLeftPerspective': 'Diagonálny pohľad na vozidlo spredu zľava',
	'review.stepDescription.vehicleRearRightPerspective':
		'Diagonálny pohľad na vozidlo zozadu sprava',
	'review.stepDescription.vehicleFrontRightPerspective':
		'Diagonálny pohľad na vozidlo spredu sprava',
	'review.stepDescription.windshield': 'Čelné sklo',
	'review.stepDescription.vinPicture': 'VIN číslo',
	'review.stepDescription.overallDashboard': 'Celkový pohľad na palubnú dosku',
	'review.stepDescription.mileage': 'Najazdené kilometre',
	'review.stepDescription.registrationDocument': 'Fotka technického preukazu (predná strana)',
	'review.stepDescription.registrationDocumentInside': 'Fotka technického preukazu (zadná strana)',
	'thankYou.message': 'Teraz ich skontrolujú naši likvidátori.',
	'thankYou.paragraph.first': 'Ďakujeme',
	'thanks.headline.first': 'Ďakujeme, fotky ste nám úspešne poslali',
	'timeout.headline.first': 'Digitálna obhliadka sa nenašla',
	'timeout.paragraph.first': 'Platnosť vašej obhliadky vypršala alebo ste použili nesprávny odkaz.',
	'vehicleFrontLeftPerspectiveImage.description':
		'Odfoťte vozidlo diagonálne spredu zľava tak, aby bolo celé v zábere a evidenčné číslo bolo viditeľné.',
	'vehicleFrontLeftPerspectiveImage.title': 'Diagonálny pohľad na vozidlo spredu zľava',
	'vehicleFrontRightPerspectiveImage.description':
		'Odfoťte vozidlo diagonálne spredu sprava tak, aby bolo celé v zábere a evidenčné číslo bolo viditeľné.',
	'vehicleFrontRightPerspectiveImage.title': 'Diagonálny pohľad na vozidlo spredu sprava',
	'vehicleMileage.description': 'Odfoťte stav najazdených kilometrov tak, aby bol dobre čitateľný.',
	'vehicleRearLeftPerspectiveImage.description':
		'Odfoťte vozidlo diagonálne zozadu zľava tak, aby bolo celé v zábere a evidenčné číslo bolo viditeľné.',
	'vehicleRearLeftPerspectiveImage.title': 'Diagonálny pohľad na vozidlo zozadu zľava',
	'vehicleRearRightPerspectiveImage.description':
		'Odfoťte vozidlo diagonálne zozadu sprava tak, aby bolo celé v zábere a evidenčné číslo bolo viditeľné.',
	'vehicleRearRightPerspectiveImage.title': 'Diagonálny pohľad na vozidlo zozadu sprava',
	'vinPicture.description':
		'Odfoťte zblízka VIN číslo vozidla tak, aby boli všetky znaky dobre čitateľné.',
	'vinPicture.title': 'VIN číslo',
	'windshieldImage.description':
		'Odfoťte čelné sklo tak, aby bolo celá plocha skla dobre viditeľná.',
	'windshieldImage.title': 'Čelné sklo',
	'validationContainer.correct': 'V poriadku',
	'photoUploading.title': 'Nahrávanie',
	'photoAnalyzing.title': 'Analyzovanie',
	'photoLoading.title': 'Načítavanie',
	'camera.darkWarning':
		'Prostredie je príliš tmavé. Pre lepšiu kvalitu fotky zabezpečte lepšie osvetlenie.',
	'landscapeModeDetected.title': 'Automatické otáčanie je zapnuté',
	'landscapeModeDetected.text':
		'Pre správne používanie fotoaparátu vypnite automatické otáčanie obrazovky vo svojom smartfóne.',
	'button.changeImage': 'Zmeniť fotku',
	'button.acceptImage': 'Potvrdiť fotku',
	'button.acceptMileage': 'Potvrdiť',
	'button.anotherImage': 'Odfotiť znova',
	'invalidFile.size.title': 'Nesprávna veľkosť fotky',
	'invalidFile.size.description': 'Veľkosť fotky prekračuje maximálny povolený limit.',
	'invalidFile.extension.title': 'Nepodporovaný typ súboru',
	'invalidFile.extension.description':
		'Tento typ súboru nie je podporovaný. Podporované typy súborov: .jpg, .jpeg, .jfif, .heic, .heif, .png, .bmp.',
	'connectionError.title': 'Chyba pripojenia',
	'connectionError.description': 'Vyskytla sa chyba pripojenia. Nahrajte fotku znova.',
	'missingPhoto.title': 'Chýbajúca fotka',
	'missingPhoto.description': 'Zdá sa, že chýba fotka. Pre pokračovanie pridajte chýbajúcu fotku.',
};

export default messages;
